import { Configuration, LogLevel } from "@azure/msal-browser";

// MSAL configuration for Entra ID (Azure AD)
export const msalConfig: Configuration = {
  auth: {
    clientId: "0361246f-3dcb-4127-a710-f2c08aaae01b", // Your Application (client) ID
    authority: "https://login.microsoftonline.com/9e46e279-e6f4-4624-b216-747c03e63ea2", // Your Tenant ID
    redirectUri: window.location.origin, // Must match Redirect URI configured in Azure App Registration
    postLogoutRedirectUri: "/", // Redirect here after logout
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // "sessionStorage" or "localStorage"
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false
    },
    // Increase load frame timeout to prevent timeouts during initial load.
    loadFrameTimeout: 120000, // 120 seconds
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
};

// Add scopes here for access token to be used at Microsoft Graph API endpoints.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
